import ProductFamily from './productFamily';

/**
 * @class ProductFamilyStore
 */
export default class ProductFamilyStore {
    itemIdToProductFamilyMap = new Map();

    addProductFamily(sizes) {
        const productFamily = new ProductFamily(sizes);

        Object.values(sizes).forEach((accessories) => {
            Object.values(accessories).forEach((aligns) => {
                Object.values(aligns).forEach((versions) => {
                    Object.values(versions).forEach((itemData) => {
                        this.itemIdToProductFamilyMap.set(itemData.itemId, productFamily);
                    });
                });
            });
        });
    }

    getByItemId(itemId) {
        return this.itemIdToProductFamilyMap.get(itemId);
    }
}
